/* eslint-disable no-unused-vars */
import { QuestionFormField, QuestionFormFieldType } from './questionFormField'

/**
 * Creates an instance of TextField.
 * @typedef {Object} TextFieldType
 * @property {string} placeholder
 *
 * @typedef {QuestionFormFieldType & TextFieldType} TextFieldExtendType
 */

/**
 * Represents a text form field.
 * @class
 */
export class TextField extends QuestionFormField {
  /**
   * Create a new TextField.
   * @param {TextFieldExtendType} params
   */
  constructor(params) {
    super(params)
    this.placeholder = params.placeholder
  }
}
